export default {
  deliveryDocuments(state) {
    return state.document ? state.document.itemsSplittedByDeliveryDocument : [];
  },
};
